module.exports = __webpack_public_path__ + "static/media/white.b417d3ee.ogg";